import { DIRECTIONS } from "react-with-direction/dist/DirectionProvider";

export const DEFAULT_DIRECTION = DIRECTIONS.LTR;
export const DEFAULT_LOCALE = "en";
export const DEFAULT_CURRENCY = "SAR";
